/* eslint no-tabs: "off", indent: "off" */

import {
	CANCEL_FTUX,
	CLEAR_FALLBACK_WARNING,
	CLOSE_DMA_TOOLTIP,
	CLOSE_GENERIC_TOOLTIP,
	CLOSE_GENERIC_LIGHT_TOOLTIP,
	CLOSE_MAP_INFO_TOOLTIP,
	CLOSE_PREDICTIVE_HEADER_TOOLTIP,
	CLOSE_USER_DROPDOWN,
	FILTER_CONTENT_BY_DATE,
	INIT_FTUX,
	OPEN_DMA_TOOLTIP,
	OPEN_PREDICTIVE_HEADER_TOOLTIP,
	OPEN_GENERIC_TOOLTIP,
	OPEN_GENERIC_LIGHT_TOOLTIP,
	OPEN_MAP_INFO_TOOLTIP,
	OPEN_TAG_TOOLTIP,
	SET_CURRENT_ZOOM,
	SHOW_SHARE_FAIL_MESSAGE,
	RESET_ARTICLES_CURSOR_POS,
} from "actions/constants.js";

import { updateData, updateLowerData, updateDataByDate, updateGraphData } from "actions/data.js";
import { updateDataCompare } from "actions/dataCompare.js";
import { setCookie } from "lib/helpers/loginHelpers.js";
import { findTourElementPosition } from "lib/helpers/helpers.js";
import { addConfigFilters } from "lib/helpers/filterHelpers.js";
import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";
import tours from "lib/tours.js";

// Set Window Size
export function setWindowSize(windowSize) {
	return {
		type: "setWindowSize",
		windowSize,
	};
}

export function updateScrollPosition(scrollPosition) {
	return {
		type: "updateScrollPosition",
		scrollPosition,
	};
}

export function setStagingData(stagingData) {
	return {
		type: "setStagingData",
		stagingData,
	};
}

// Main navigation - between narratives
export function narSelect(narrative) {
	// console.log("narSelect", narrative);

	return (dispatch, getState) => {
		const { perspective, contentFilteredByDate, currentZoom, isolateTopic, activeKeywords } = getState().base; // perspective doesn't change on narSelect
		const { projectMapConfig, showTopicsInGraph } = getState().projectConfig;
		const { varStore } = getState().storage;
		const prevNarrative = getState().base.activeNarrativeData;

		// NOTE: "All Topics" is forced open in the sidebar logic
		// if clicking the active topic, there's no data update - just toggle isolateTopic
		if (prevNarrative.id === narrative.id) {
			dispatch({ type: isolateTopic ? "releaseIsolateTopic" : "isolateTopic" });
		} else {
			dispatch({ type: RESET_ARTICLES_CURSOR_POS });
			dispatch({ type: "releaseIsolateTopic" });
			const configStateFilter =
				// !varStore.narratives[perspective].currentZoom.name &&
				projectMapConfig && projectMapConfig.narratives && projectMapConfig.narratives.state;
			const baseFilters = perspective === "Source" ? getState().base.sourceFilters : getState().base.audienceFilters;
			// Don't retain previous filters if there is a map config
			const activeFilters = configStateFilter
				? addConfigFilters([], configStateFilter, baseFilters)
				: varStore.narratives[perspective].filters;

			dispatch(
				updateData({
					nar: narrative,
					perspective,
					currentZoom,
					activeFilters,
					// Don't retain previous entity filters if there is a map config
					entityFilters: configStateFilter ? [] : varStore.narratives[perspective].entityFilters,
					keywords: activeKeywords,
					mapHighlightId: configStateFilter ? configStateFilter.geoState : varStore.narratives[perspective].mapHighlightId,
					contentFilteredByDate,
				})
			);
			dispatch({ type: "highlightCountyOff" });

			if (configStateFilter) {
				// NOTE: not passing color on purpose
				dispatch({
					type: "highlightMap",
					data: configStateFilter,
					startDate: currentZoom.begin,
					endDate: currentZoom.end,
				});
			}
			dispatch({ type: "narSelect", narrative, showTopicsInGraph });
		}
	};
}

export function togglePerspective() {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, activeKeywords } = getState().base;
		const { varStore } = getState().storage;

		// This is where the state toggles (getting passed the old state)
		const newPerspective = perspective === "Source" ? "Audience" : "Source";
		const filtersList = varStore.narratives[newPerspective].filters;

		dispatch(
			updateData({
				nar: activeNarrativeData,
				perspective: newPerspective,
				currentZoom: varStore.narratives[perspective].currentZoom,
				entityFilters: varStore.narratives[newPerspective].entityFilters,
				activeFilters: filtersList,
				keywords: activeKeywords,
				mapHighlightId: varStore.narratives[perspective].mapHighlightId,
				contentFilteredByDate: varStore.narratives[perspective].contentFilteredByDate,
			})
		);
		dispatch({ type: "togglePerspective", perspective: newPerspective, filtersList });
	};
}

export const openFilterPanel = () => {
	return {
		type: "openFilterPanel",
	};
};
export const closeFilterPanel = () => {
	return {
		type: "closeFilterPanel",
	};
};

export const toggleSidebar = () => {
	return (dispatch, getState) => {
		dispatch({ type: getState().base.sidebarOpen ? "closeSidebar" : "openSidebar" });
	};
};

export const toggleSidebarEntitiesDrawer = () => {
	return (dispatch, getState) => {
		if (getState().base.sidebarEntitiesOpen) {
			dispatch({ type: "closeSidebarEntities" });
		} else {
			dispatch({ type: "openSidebarEntities" });
		}
	};
};

export const toggleSidebarEntitySelect = () => {
	return (dispatch, getState) => {
		if (getState().base.sidebarEntitySelectOpen) {
			dispatch({ type: "closeSidebarEntitiesSelect" });
		} else {
			dispatch({ type: "openSidebarEntitiesSelect" });
		}
	};
};
export const closeSidebarEntitySelect = () => {
	return {
		type: "closeSidebarEntitiesSelect",
	};
};

export const clearFallbackWarning = () => {
	return {
		type: CLEAR_FALLBACK_WARNING,
	};
};

// ------------- Modals ------------
// Support modal & dropdown select
export function openSupportModal() {
	return {
		type: "openSupportModal",
	};
}
export function closeSupportModal() {
	return {
		type: "closeSupportModal",
	};
}
export function supportSubjectOptionSelected(data) {
	return {
		type: "supportSubjectOptionSelected",
		data,
	};
}

// Disabled filters modal
export function openDisabledFilterTooltip(params) {
	const { position } = params;
	return (dispatch, getState) => {
		dispatch({
			type: "openDisabledFilterTooltip",
			position,
			text: getState().projectConfig.disableFiltersMessage,
		});
	};
}
export function closeDisabledFilterTooltip() {
	return {
		type: "closeDisabledFilterTooltip",
	};
}

// Change log modal
export function openChangeLog() {
	return {
		type: "openChangeLog",
	};
}
export function closeChangeLog() {
	return {
		type: "closeChangeLog",
	};
}

// User Dropdown
export function openUserDropdown() {
	return {
		type: "openUserDropdown",
	};
}
export function closeUserDropdown() {
	return {
		type: CLOSE_USER_DROPDOWN,
	};
}

// // Power Warning modal
// export function openPowerWarningModal() {
// 	return {
// 		type: 'openPowerWarningModal',
// 	};
// }
// export function closePowerWarningModal() {
// 	return {
// 		type: 'closePowerWarningModal',
// 	};
// }

// // Advanced Search Mode
// export function openAdvancedSearchMode(tags1, tags2, globalFilters) {
// 	const queryString = makeQueryString(tags1, tags2, globalFilters);
// 	return {
// 		type: 'openAdvancedSearchMode',
// 		queryString,
// 	};
// }
// export function closeAdvancedSearchMode() {
// 	return {
// 		type: 'closeAdvancedSearchMode',
// 	};
// }

export function toggleFilterDropdown(isOpen) {
	return {
		type: isOpen ? "closeFilterDropdown" : "openFilterDropdown",
	};
}

// Filter content by date (on graph click only). Will resolve in one day/unit
export function filterContentByDate(unit, left) {
	return (dispatch, getState) => {
		const { 
			activeNarrativeData,
			aggregationLevel,
			perspective, 
			activeKeywords
		} = getState().base;
		const { varStore } = getState().storage;

		const adjustedBegin = adjustStartDateForAggregation({ 
			startDate: Number(unit), 
			aggregationLevel,
		});
		const adjustedEnd = Number(unit) + (24 * 60 * 60 * 1000) - 1;
		const contentFilteredByDate = unit
		? {
				begin: adjustedBegin,
				end: adjustedEnd,
				indicatorWidth: 3,
				indicatorOffset: left,
			}
		: false;

		dispatch({ type: RESET_ARTICLES_CURSOR_POS });
		dispatch(
			updateDataByDate({
				nar: activeNarrativeData,
				perspective,
				currentZoom: varStore.narratives[perspective].currentZoom,
				activeFilters: varStore.narratives[perspective].filters,
				entityFilters: varStore.narratives[perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore.narratives[perspective].mapHighlightId,
				contentFilteredByDate,
				offset: 0,
			})
		);
		dispatch({ type: FILTER_CONTENT_BY_DATE, contentFilteredByDate });
	};
}
// For updating contentFilteredByDate after window/graph resize
export const formatContentFilteredByDate = (graphSize, trimmedTrendDates) => {
	return {
		type: "formatContentFilteredByDate",
		graphSize,
		trimmedTrendDates,
	};
};

// clears filterContentByDate indicator
export function clearIndicator() {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, activeKeywords } = getState().base;
		const { varStore } = getState().storage;
		dispatch({ type: RESET_ARTICLES_CURSOR_POS });
		dispatch(
			updateDataByDate({
				nar: activeNarrativeData,
				perspective,
				currentZoom: varStore.narratives[perspective].currentZoom,
				activeFilters: varStore.narratives[perspective].filters,
				entityFilters: varStore.narratives[perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore.narratives[perspective].mapHighlightId,
				contentFilteredByDate: false,
				offset: 0,
			})
		);
		dispatch({ type: "clearIndicator" });
	};
}

export const zoomComplete = (zoom) => {
	return {
		type: SET_CURRENT_ZOOM,
		currentZoom: zoom,
	};
};
export const zoomInit = (zoom) => {
	return (dispatch, getState) => {
		const { activeNarrativeData, perspective, activeKeywords } = getState().base;
		const { varStore } = getState().storage;
		dispatch({ type: RESET_ARTICLES_CURSOR_POS });
		dispatch(
			updateLowerData({
				nar: activeNarrativeData,
				perspective,
				currentZoom: zoom,
				activeFilters: varStore.narratives[perspective].filters,
				entityFilters: varStore.narratives[perspective].entityFilters,
				keywords: activeKeywords,
				mapHighlightId: varStore.narratives[perspective].mapHighlightId,
				contentFilteredByDate: false,
				offset: 0,
			})
		);
	};
};

export const dataTypeSelect = (dataType) => {
	return (dispatch) => {
		dispatch(updateGraphData({ dataType }));
	};
};

// --------- Tooltips ---------
export const closeGenericTooltip = () => {
	return {
		type: CLOSE_GENERIC_TOOLTIP,
	};
};
export const openGenericTooltip = (params) => {
	const { position, text, width, color } = params;
	return (dispatch) => {
		dispatch({
			type: OPEN_GENERIC_TOOLTIP,
			position,
			text,
			width,
			color,
		});
	};
};
export const toggleGenericTooltip = (params) => {
	return (dispatch, getState) => {
		if (getState().commonUI.genericTooltipOpen) {
			dispatch(closeGenericTooltip());
		} else {
			dispatch(openGenericTooltip(params));
		}
	};
};

export const closeGenericLightTooltip = () => {
	return {
		type: CLOSE_GENERIC_LIGHT_TOOLTIP,
		payload: {
			genericTooltipOpen: false,
			genericTooltipPosition: { top: 0, left: 0 },
			genericTooltipText: "",
			genericTooltipWidth: 300,
		},
	};
};
export const openGenericLightTooltip = (params) => {
	const { position, text, width } = params;
	return (dispatch) => {
		dispatch({
			type: OPEN_GENERIC_LIGHT_TOOLTIP,
			position,
			text,
			width: width || 300,
		});
	};
};
export const toggleGenericLightTooltip = (params) => {
	return (dispatch, getState) => {
		if (getState().commonUI.genericLightTooltipOpen) {
			dispatch(closeGenericLightTooltip());
		} else {
			dispatch(openGenericLightTooltip(params));
		}
	};
};

export function closeTagTooltip() {
	return {
		type: "closeTagTooltip",
	};
}
export function openTagTooltip(position, nar) {
	return (dispatch, getState) => {
		dispatch({
			type: OPEN_TAG_TOOLTIP,
			payload: {
				tagTooltipColor: getState().projectConfig.darkUI ? nar.color.dark : nar.color.light,
				tagTooltipElementPosition: position,
				tagTooltipOpen: true,
				tagTooltipText: {
					header: nar ? nar.header : "",
					bullets: nar ? nar.bullets : "",
				},
			},
		});
	};
}

export function closeCountryTooltip() {
	return {
		type: "closeCountryTooltip",
	};
}
export function openCountryTooltip(position, country) {
	return {
		type: "openCountryTooltip",
		position,
		country,
	};
}

export function closeFeaturedTooltip() {
	return {
		type: "closeFeaturedTooltip",
	};
}
export function openFeaturedTooltip(position, nar) {
	return {
		type: "openFeaturedTooltip",
		position,
		nar,
	};
}

export function closeSharesTooltip() {
	return {
		type: "closeSharesTooltip",
	};
}
export function openSharesTooltip(position, article) {
	return {
		type: "openSharesTooltip",
		position,
		article,
	};
}

export function closeVideoTooltip() {
	return {
		type: "closeVideoTooltip",
	};
}
export function openVideoTooltip(position) {
	return {
		type: "openVideoTooltip",
		position,
	};
}

export function closeSynopsisTooltip() {
	return {
		type: "closeSynopsisTooltip",
	};
}
export function openSynopsisTooltip(position) {
	return {
		type: "openSynopsisTooltip",
		position,
	};
}

export function openSocialGraphTooltip(position) {
	return {
		type: "openSocialGraphTooltip",
		position,
	};
}
export function closeSocialGraphTooltip() {
	return {
		type: "closeSocialGraphTooltip",
	};
}

export function openNoReactionInAIModeTooltip(position) {
	return {
		type: "openNoReactionInAIModeTooltip",
		position,
	};
}
export function closeNoReactionInAIModeTooltip() {
	return {
		type: "closeNoReactionInAIModeTooltip",
	};
}

// -------- Predictive Header Tooltip ---------
export function closePredictiveHeaderTooltip() {
	return {
		type: CLOSE_PREDICTIVE_HEADER_TOOLTIP,
		payload: { predictiveHeaderTooltipOpen: false },
	};
}
export function openPredictiveHeaderTooltip(params) {
	const { position, text } = params;
	return {
		type: OPEN_PREDICTIVE_HEADER_TOOLTIP,
		payload: {
			predictiveHeaderTooltipOpen: true,
			predictiveHeaderTooltipPosition: position,
			predictiveHeaderTooltipText: text || "",
		},
	};
}

// ----------

export function putFocusBack() {
	return {
		type: "putFocusBack",
	};
}
export function fallbackErrorMessageInit() {
	return (dispatch) => {
		setTimeout(() => {
			dispatch({ type: "resolveFallbackError" });
		}, 60000);
	};
}

export function clearDeleteFilterSetError() {
	return {
		type: "clearDeleteFilterSetError",
	};
}

// ----- colorblind mode -----
export function initColorblindMode(isColorblind) {
	return (dispatch) => {
		dispatch({ type: CLOSE_USER_DROPDOWN });
		dispatch({
			type: isColorblind && isColorblind !== "false" ? "enterColorblindMode" : "leaveColorBlindMode",
		});
	};
}
export function toggleColorblindMode(isActive, userId) {
	setCookie("colorblind", !isActive, userId);
	return (dispatch) => {
		dispatch({ type: CLOSE_USER_DROPDOWN });
		// Timeout is to hide text change in the dropdaown
		setTimeout(() => {
			dispatch({ type: isActive ? "leaveColorBlindMode" : "enterColorblindMode" });
		}, 100);
	};
}

export function toggleUITheme(userId) {
	return (dispatch, getState) => {
		const darkUI = !getState().projectConfig.darkUI; // Toggles here
		setCookie("uitheme", darkUI, userId);
		dispatch({ type: CLOSE_USER_DROPDOWN });
		// Timeout is to hide text change in the dropdaown
		setTimeout(() => {
			dispatch({ type: "setUITheme", darkUI });
		}, 100);
	};
}
export function initUITheme(darkUIString) {
	return (dispatch) => {
		dispatch({ type: "setUITheme", darkUI: darkUIString === "true" });
	};
}

export function initAIMode(aiOnlyString) {
	return (dispatch, getState) => {
		const AIMode = aiOnlyString && aiOnlyString !== "false" && getState().projectConfig.aiToggle;
		dispatch({ type: CLOSE_USER_DROPDOWN });
		dispatch({
			type: AIMode ? "enterAIMode" : "leaveAIMode",
		});
	};
}
export function toggleAIMode(userId) {
	return (dispatch, getState) => {
		const aiOnly = !getState().commonUI.aiOnly; // Toggles here
		const { hideEntitiesInAIMode } = getState().projectConfig;
		const hideEntities = aiOnly && hideEntitiesInAIMode;
		setCookie("ai", aiOnly, userId);
		const {
			activeNarrativeData,
			contentFilteredByDate,
			currentFiltersList,
			currentZoom,
			entityFilters,
			mapHighlightId,
			perspective,
			activeKeywords,
		} = getState().base;
		const { location } = getState().router;

		const narrativesMode = location && location.pathname === "/narratives";
		const compareMode = location && location.pathname === "/compare";
		const moeMode = location && location.pathname === "/moe";
		const eventMode = location && location.pathname === "/events";

		dispatch({ type: CLOSE_USER_DROPDOWN });
		// Timeout is to hide text change in the dropdown
		setTimeout(() => {
			dispatch({ type: aiOnly ? "enterAIMode" : "leaveAIMode" });
		}, 100);

		// Refetch all data - Usually refetch Narratives tab (all non-narratives options are modals)
		// Timeout is to allow aiOnly to be set correctly
		setTimeout(() => {
			if (narrativesMode || compareMode || moeMode || eventMode) {
				dispatch(
					updateData({
						activeFilters: currentFiltersList,
						contentFilteredByDate,
						entityFilters: hideEntities ? [] : entityFilters,
						keywords: activeKeywords,
						currentZoom,
						mapHighlightId,
						nar: activeNarrativeData,
						perspective,
					})
				);
			}

			if (compareMode || moeMode || eventMode) {
				const leftData = getState().leftCompare;
				const rightData = getState().rightCompare;

				dispatch(
					updateDataCompare({
						side: "Left",
						narrative: leftData.activeNarrativeData,
						perspective: leftData.perspective,
						currentZoom: leftData.currentZoom,
						activeFilters: leftData.filtersList,
						entityFilters: hideEntities ? [] : leftData.entityFilters,
						keywords: leftData.activeKeywords,
						mapHighlightId: leftData.mapHighlightId,
						contentFilteredByDate: leftData.contentFilteredByDate,
						eventMode,
					})
				);
				dispatch(
					updateDataCompare({
						side: "Right",
						narrative: rightData.activeNarrativeData,
						perspective: rightData.perspective,
						currentZoom: rightData.currentZoom,
						activeFilters: rightData.filtersList,
						entityFilters: hideEntities ? [] : rightData.entityFilters,
						keywords: rightData.activeKeywords,
						mapHighlightId: rightData.mapHighlightId,
						contentFilteredByDate: rightData.contentFilteredByDate,
						eventMode,
					})
				);
			}
			// TODO: Install requests for graph and compare, if a project ever supports these tabs and the aiToggle
			// if (graphMode) {
			// 	dispatch(fetchTimeseriesList({}));
			// 	dispatch(fetchGraphTabTimeseries({
			// 		narrative, perspective, filtersList
			// 	}));
			// }
			// if (curatedMode) {
			// }
		}, 200);
	};
}

// --------- Info tooltips -----------
// Narrative Tooltip is still in the base reducer
export function closeNarrativeTooltip() {
	return {
		type: "closeNarrativeTooltip",
	};
}
export function openNarrativeTooltip(position, nar) {
	return {
		type: "openNarrativeTooltip",
		position,
		nar,
	};
}
export function toggleNarrativeTooltip(position, nar) {
	return (dispatch, getState) => {
		const isOpen = getState().base.narrativeTooltip;
		dispatch({
			type: isOpen ? "closeNarrativeTooltip" : "openNarrativeTooltip",
			position,
			nar,
		});
	};
}
export function closePerspectiveInfoTooltip() {
	return {
		type: "closePerspectiveInfoTooltip",
	};
}
export function openPerspectiveInfoTooltip(position) {
	return {
		type: "openPerspectiveInfoTooltip",
		position,
	};
}
export function togglePerspectiveInfoTooltip(position) {
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.perspectiveInfoTooltipOpen;
		dispatch({
			type: isOpen ? "closePerspectiveInfoTooltip" : "openPerspectiveInfoTooltip",
			position,
		});
	};
}
export function closeMapInfoTooltip() {
	return {
		type: CLOSE_MAP_INFO_TOOLTIP,
	};
}
export function openMapInfoTooltip(params) {
	const { position, perspective } = params;
	return {
		type: OPEN_MAP_INFO_TOOLTIP,
		position,
		perspective,
	};
}
export function toggleMapInfoTooltip(params) {
	const { position, perspective } = params;
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.mapInfoTooltipOpen;
		dispatch({
			type: isOpen ? CLOSE_MAP_INFO_TOOLTIP : OPEN_MAP_INFO_TOOLTIP,
			position,
			perspective,
		});
	};
}
export function closeDmaTooltip() {
	return {
		type: CLOSE_DMA_TOOLTIP,
	};
}
export function openDmaTooltip(params) {
	const { position } = params;
	return {
		type: OPEN_DMA_TOOLTIP,
		position,
	};
}
export function toggleDmaTooltip(params) {
	const { position } = params;
	return (dispatch, getState) => {
		const { dmaTooltipOpen } = getState().commonUI;
		dispatch({
			type: dmaTooltipOpen ? CLOSE_DMA_TOOLTIP : OPEN_DMA_TOOLTIP,
			position,
		});
	};
}
export function closeContentInfoTooltip() {
	return {
		type: "closeContentInfoTooltip",
	};
}
export function openContentInfoTooltip(params) {
	const { position, text } = params;
	return {
		type: "openContentInfoTooltip",
		position,
		text,
	};
}
export function toggleContentInfoTooltip(params) {
	const { position, text } = params;
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.contentInfoTooltipOpen;
		dispatch({
			type: isOpen ? "closeContentInfoTooltip" : "openContentInfoTooltip",
			position,
			text,
		});
	};
}
export function closeExportContentInfoTooltip() {
	return {
		type: "closeExportContentInfoTooltip",
	};
}
export function openEntityFiltersTooltip(params) {
	const { position, text } = params;
	return {
		type: "openEntityFiltersTooltip",
		position,
		text,
	};
}
export function toggleEntityFiltersTooltip(params) {
	const { position, text } = params;
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.entityFiltersTooltipOpen;
		dispatch({
			type: isOpen ? "closeEntityFiltersTooltip" : "openEntityFiltersTooltip",
			position,
			text,
		});
	};
}
export function closeEntityFiltersTooltip() {
	return {
		type: "closeEntityFiltersTooltip",
	};
}
export function openExportContentInfoTooltip(params) {
	const { position, narrativeName, currentZoom, currentFiltersList, articleCount } = params;
	return {
		type: "openExportContentInfoTooltip",
		position,
		narrativeName,
		currentZoom,
		currentFiltersList,
		articleCount,
	};
}
export function toggleExportContentInfoTooltip(params) {
	const { position, narrativeName, currentZoom, currentFiltersList, articleCount } = params;
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.exportContentInfoTooltipOpen;
		dispatch({
			type: isOpen ? "closeExportContentInfoTooltip" : "openExportContentInfoTooltip",
			position,
			narrativeName,
			currentZoom,
			currentFiltersList,
			articleCount,
		});
	};
}
export function closeEntitiesInfoTooltip() {
	return {
		type: "closeEntitiesInfoTooltip",
	};
}
export function openEntitiesInfoTooltip(position, filtersSentenceFragment, entitiesLength, narrativeData) {
	return {
		type: "openEntitiesInfoTooltip",
		position,
		filtersSentenceFragment,
		entitiesLength,
		narrativeData,
	};
}
export function toggleEntitiesInfoTooltip(position, filtersSentenceFragment, entitiesLength, narrativeData) {
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.entitiesInfoTooltipOpen;
		dispatch({
			type: isOpen ? "closeEntitiesInfoTooltip" : "openEntitiesInfoTooltip",
			position,
			filtersSentenceFragment,
			entitiesLength,
			narrativeData,
		});
	};
}
export function closeFiltersInfoTooltip() {
	return {
		type: "closeFiltersInfoTooltip",
	};
}
export function openFiltersInfoTooltip(position, perspective) {
	return {
		type: "openFiltersInfoTooltip",
		position,
		perspective,
	};
}
export function toggleFiltersInfoTooltip(position, perspective) {
	return (dispatch, getState) => {
		const isOpen = getState().commonUI.filtersInfoTooltipOpen;
		dispatch({
			type: isOpen ? "closeFiltersInfoTooltip" : "openFiltersInfoTooltip",
			position,
			perspective,
		});
	};
}



export function toggleEnglishTranslation() {
	return (dispatch, getState) => {
		const { entityLanguage } = getState().commonUI;
		dispatch({
			type: "toggleEnglishTranslation",
			entityLanguage: entityLanguage === "english" ? "original" : entityLanguage === "original" ? "english" : false,
		});
	};
}

// ---------- Share -----------
export function closeShareModal() {
	return (dispatch) => {
		dispatch({ type: "closeShareModal" });
		dispatch({ type: CLOSE_USER_DROPDOWN });
	};
}

export function closeNoAccessModal() {
	return (dispatch) => {
		dispatch({ type: "closeNoAccessModal" });
	};
}

export function showShareFailMessage(url) {
	const failedSharedURL = url;
	// This causes an additional reload
	const baseURL = window.location.href.split("?")[0];
	window.history.pushState({}, document.title, baseURL);
	return (dispatch) => {
		dispatch({
			type: SHOW_SHARE_FAIL_MESSAGE,
			payload: { failedSharedURL: `${baseURL}?share=${failedSharedURL}` },
		});
	};
}

// ---------- FTUX -----------
export const initCrosstabsFtux = () => {
	const tour = tours.crosstabs[0];
	return (dispatch) => {
		dispatch({
			type: INIT_FTUX,
			text: tour.text,
			position: findTourElementPosition(tour),
		});
	};
};
export const ftuxBack = () => {
	// const tour = tours.crosstabs[0];
	console.log("ftuxBack - need to write");
	return (dispatch) => {
		// dispatch({
		// 	type: INIT_FTUX,
		// 	text: tour.text,
		// 	// position: findTourElementPosition(tour),
		// 	position: { top: 100, left: 100 },
		// });
	};
};
export const ftuxCancel = () => {
	return (dispatch) => {
		dispatch({
			type: CANCEL_FTUX,
		});
	};
};
export const ftuxNext = () => {
	// const tour = tours.crosstabs[0];
	console.log("ftuxNext - need to write");
	return (dispatch) => {
		// dispatch({
		// 	type: INIT_FTUX,
		// 	text: tour.text,
		// 	// position: findTourElementPosition(tour),
		// 	position: { top: 100, left: 100 },
		// });
	};
};
